import {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {REST_URL} from "../../../component/const/Const";

export const EditPopup = ({close, id, tableName, isAdding = false}) => {
    useEffect(() => {
        init()
    }, [])

    const init = async () => {
        if (id === -1 && isAdding) {
            console.log('id', id);
            await setTestData()
            const list = []
            for (let i = 0; i < 3; i++) {
                const data = await fetchData(tableName, i)
                if (data.hasOwnProperty('period')) delete data.period;
                if (data.hasOwnProperty('index')) delete data.index;
                list.push({[`${i + 1}교시`]: data})
            }
            console.log(list)
            setMockInfo(list)
            return;
        }
        if (id === -1 && !isAdding) {
            const data = await fetchData(tableName)
            if (data.hasOwnProperty('period')) delete data.period;
            if (data.hasOwnProperty('index')) delete data.index;
            setMockInfo({[tableName]: data});
            return;
        }
        const tableList = await axios.get(`${REST_URL}rpc/get_table?v_name=${tableName}`)
        if (tableList.data == null) {
            return;
        }
        const obj = Object.fromEntries(tableList.data.map(key => [key, null]));

        for (let i of Object.keys(obj)) {
            obj[i] = await fetchData(i);
        }
        setMockInfo(obj) //나중에 테이블 긁어오는 api를 생각해서 이렇게 적었는데 나중에 promise.all 적용시키셔도 좋을 거 같습니다
    }

    const [mockInfo, setMockInfo] = useState(null);//불러와야하는 테이블을 가져오는 api가 작동을 안해서 일단 이렇게 두겠습니다
    const fetchData = async (key, fetchId = 0) => {
        try {
            const {data} = await axios.get(`${REST_URL}rpc/get_with_type_id?t_name=${key}&id=${id === -1 ? fetchId : id}`);
            const rawInfo = data[0][0]
            const mockInfo = {};
            for (const [key, {value, type}] of Object.entries(rawInfo)) {
                if (key.includes("id")) continue; //id는 수정 못하게 전부 지움
                const field = {value, type};
                if (type === "USER-DEFINED") {
                    try {
                        const {data: options} = await axios.get(
                            `${REST_URL}rpc/get_enum_values?p_enum_name=${key}`
                        );
                        field.options = options;
                    } catch (err) {
                        console.warn(`enum(${type}) 불러오기 실패`, err);
                    }
                }

                mockInfo[key] = field;
            }
            return mockInfo
        } catch (err) {
            console.error(`"데이터 fetch 실패:" ${key} `, err);
            return null
        }
    };

    const handleChange = (tableKey, fieldKey, newValue, index = 0) => {
        if (Array.isArray(mockInfo)) {
            const mock = [...mockInfo];
            mock[index][tableKey][fieldKey] = newValue;
            setMockInfo(mock);
        } else setMockInfo(prev => ({
            ...prev,
            [tableKey]: {
                ...prev[tableKey],
                [fieldKey]: {
                    ...prev[tableKey][fieldKey],
                    value: newValue
                }
            }
        }));
    };

    const inputStyle = "border px-4 py-2 rounded w-full  text-center !mx-0"
    const renderInput = (tableKey, key, item, index = 0) => {
        if (item.type === "date") {
            return (
                <input key={`EdPU${tableKey}${key}${item}`}
                       type="date"
                       value={item.value}
                       onChange={e => handleChange(tableKey, key, e.target.value, index)}
                       className={`${inputStyle}`}
                />
            );
        } else if (item.type === "text" || item.type === "integer" || item.type === "numeric" || item.type === "number" || item.type === "string" || item.type === "smallint") {
            return <input key={`EdPU${tableKey}${key}${item}`} type="text" value={item.value}
                          onChange={e =>
                              handleChange(tableKey, key, item.type === "integer" || item.type === "numeric" || item.type === "number" || item.type === "smallint" ?
                                  isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value) : e.target.value, index)}
                          className={`${inputStyle}`}
            />
        } else if (item.type === "time") {
            return <input key={`EdPU${tableKey}${key}${item}`}
                          type="time"
                          value={item.value}
                          onChange={e => handleChange(tableKey, key, e.target.value, index)}
                          className={`${inputStyle}`}
            />;
        } else if (item.type.includes("timestamp")) { //타임존 time, datetime-loca 여러가지 다 써봐도 그냥 input에 담을 수 없는 데이터입니다
            return <input key={`EdPU${tableKey}${key}${item}`}
                          type="datetime-local"
                          value={item.value}
                          onChange={e => handleChange(tableKey, key, e.target.value, index)}
                          className={`${inputStyle}`}
            />;
        } else if (item.type === "boolean") {
            return <div className={inputStyle}>
                <input key={`EdPU${tableKey}${key}${item}`}
                       type="checkbox"
                       checked={item.value}
                       onChange={() => handleChange(tableKey, key, !item.value, index)}
                       className="w-7 h-7 align-middle m-auto"
                />
            </div>
        } else {
            return <select onChange={e => handleChange(tableKey, key, e.target.value)}
                           defaultValue={item.value} className={`${inputStyle}`}>
                {item.options && item.options.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
            </select>
        }
    };

    const [test, setTest] = useState([]);
    const [testValue, setTestValue] = useState(-1)
    const [first, setFirst] = useState([]);
    const [firstValue, setFirstValue] = useState(0)
    const [second, setSecond] = useState([]);
    const [secondValue, setSecondValue] = useState(0)
    const [third, setThird] = useState([]);
    const [thirdValue, setThirdValue] = useState(0)

    const setTestData = async () => {
        const dataT = await axios.get(`${REST_URL}test_?select=id,test_name,test_type`)
        setTest(dataT.data)
        const dataF = await axios.get(REST_URL + 'activity_test_template?select=id,name,type&&type=eq.단답형')
        setFirst(dataF.data)
        const dataTh = await axios.get(REST_URL + 'activity_test_template?select=id,name,type&&type=eq.단답형')
        setThird(dataTh.data)
    }

    useEffect(() => {
        if (test.length === 0) return;
        setTestValue(test[0].id)
    }, [test]);

    useEffect(() => {
        if (first.length === 0) return;
        setFirstValue(first[0].id)
    }, [first]);

    useEffect(() => {
        if (second.length === 0) return;
        setSecondValue(second[0].id)
    }, [second]);

    useEffect(() => {
        if (third.length === 0) return;
        setThirdValue(third[0].id)
    }, [third]);

    const [testType, setTestType] = useState('')
    useEffect(() => {
        if (testValue === -1 || test.length === 0) return;
        const t = test.filter(x => x.id === testValue)[0].test_type;
        t === '프롬프트' ? setTestType('prompt') :
            setTestType('trans')
        axios.get(`${REST_URL}activity_test_template?select=id,name,type&&type=eq.${t}`)
            .then(res => setSecond(res.data))
    }, [testValue]);

    const renderTesting = () => <div className={`mb-8`}>
        <h1 className={`text-5xl font-extrabold text-black mb-8 `}>시험 정보</h1>
        <ul className={`flex   gap-x-8 gap-y-8 justify-start  flex-wrap mb-8`}>
            <li className="[&_input]:text-center [&_select]:text-center text-2xl  flex-shrink-0 ">
                <div className={`bg-slate-800  text-white text-center py-3 text-2xl      px-8 `}>
                    시험
                </div>
                <select defaultValue={testValue} className={`${inputStyle}`}
                        onChange={e => setTestValue(parseInt(e.target.value))}>
                    {test.length > 0 && test.map((item, index) => (
                        <option key={`${JSON.stringify(item)}${index}`} value={(item.id)}>
                            {item.test_name}
                        </option>
                    ))}
                </select>
            </li>
            <li>
                <div className={`bg-slate-800  text-white text-center py-3 text-2xl px-8 `}>
                    1교시
                </div>
                <select defaultValue={firstValue} className={`${inputStyle}`}
                        onChange={e => setFirstValue(parseInt(e.target.value))}>
                    {first.length > 0 && first.map((item, index) => (
                        <option key={`${JSON.stringify(item)}${index}`} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </li>
            <li>
                <div className={`bg-slate-800  text-white text-center py-3 text-2xl px-8 `}>
                    2교시
                </div>
                <select defaultValue={secondValue} className={`${inputStyle}`}
                        onChange={e => setSecondValue(parseInt(e.target.value))}
                >
                    {second.length > 0 && second.map((item, index) => (
                        <option key={`${JSON.stringify(item)}${index}`} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </li>
            <li>
                <div className={`bg-slate-800  text-white text-center py-3 text-2xl px-8 `}>
                    3교시
                </div>
                <select defaultValue={thirdValue} className={`${inputStyle}`}
                        onChange={e => setThirdValue(parseInt(e.target.value))}
                >
                    {third.length > 0 && third.map((item, index) => (
                        <option key={`${JSON.stringify(item)}${index}`} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </li>
        </ul>
    </div>

    const navigate = useNavigate();
    const store = async () => {
        if (Array.isArray(mockInfo)) {
            mockInfo.forEach(mock => {
                Object.keys(mock).map((key, idx) => {
                    const flatData = Object.fromEntries(
                        Object.entries(mock[key] ?? {}).map(([k, obj]) => [k, obj.value])
                    );
                    console.log(flatData);
                })
            })
        } else {
            Object.keys(mockInfo).forEach((key, idx) => {
                const flatData = Object.fromEntries(
                    Object.entries(mockInfo[key] ?? {}).map(([k, obj]) => [k, obj.value])
                );
                id === -1 ? storeOne(key, flatData)
                    :
                    axios.patch(`${REST_URL}${key}?id=eq.${id}`, flatData)
                        .then(() => {
                            alert(`${key} 업데이트 성공`)
                            navigate(-1)
                        }).catch((e) => {
                        console.error(e)
                        alert('입력되지 않은 값이 있습니다. 모든 값을 입력해주세요.')
                    })
            })
        }
    }

    const storeOne = async (key, flatData) => {
        await axios.post(`${REST_URL}${key}`, flatData, {headers: {'prefer': 'return=representation'}})
        alert('추가되었습니다.')
        navigate(-1)
    }
    const storeInstance = async (key, flatData) => {
        const {data} = await axios.get(`${REST_URL}activity_test_problem_id_max`);
        const templateArray = []
        const problems = []
        const selections = []
        const metadata = []
        let instance;

        instance = await storeNewInstance(key, flatData, 1)
        const fr = await getTemplateMetaData(firstValue)
        fr.test_id = instance.data[0].id
        metadata.push(toMetaDataArray(fr))
        await axios.post(REST_URL + 'activity_test_metadata_short', toMetaDataDetail(fr))
        const f = await getProblems(firstValue, 'short')
        templateArray.push(...f.map(it => ({...it, test_id: instance.data[0].id})))

        instance = await storeNewInstance(key, flatData, 2)
        const sr = await getTemplateMetaData(secondValue)
        sr.test_id = instance.data[0].id
        await axios.post(REST_URL + 'activity_test_metadata_' + testType, toMetaDataDetail(sr))
        metadata.push(toMetaDataArray(sr))
        const s = await getProblems(secondValue, testType)
        templateArray.push(...s.map(it => ({...it, test_id: instance.data[0].id})))

        instance = await storeNewInstance(key, flatData, 3)
        const tr = await getTemplateMetaData(thirdValue)
        tr.test_id = instance.data[0].id
        await axios.post(REST_URL + 'activity_test_metadata_short', toMetaDataDetail(tr))
        metadata.push(toMetaDataArray(tr, instance.data[0].id))
        const t = await getProblems(thirdValue, 'short')
        templateArray.push(...t.map(it => ({...it, test_id: instance.data[0].id})))

        templateArray.forEach((item, index) => {
            problems.push(toProblem(item, data[0].max + 1 + index),)
            selections.push(toSelections(item, data[0].max + 1 + index))
        })
        const selection = selections.filter(it => it !== null)
        await axios.post(REST_URL + 'activity_test_metadata', metadata.map(toMetaData))
        await axios.post(REST_URL + 'activity_test_problem', problems)
        await axios.post(REST_URL + 'activity_test_problem_selection', selection.flat())
        alert(`${key} 저장 성공`)
        navigate(-1)
    }

    return (
        <div className="absolute top-0 left-0 bg-black/70 w-full h-screen flex justify-center items-center"
             onClick={close}>
            <div className="w-[80%] h-[70%] rounded-2xl bg-white  p-8 overflow-y-scroll"
                 onClick={(e) => e.stopPropagation()}
            >
                {isAdding && test.length > 0 && renderTesting()}
                {mockInfo && Array.isArray(mockInfo) && mockInfo.map((mock, index) =>
                    Object.keys(mock).map((tableKey, idx) => <div key={idx} className={`mb-8`}>
                        <h1 className={`text-5xl font-extrabold text-black mb-8 `}
                            key={`${tableKey}${index}${idx}`}>{mock[tableKey] && tableKey}</h1>
                        <ul className={`flex   gap-x-8 gap-y-8 justify-start  flex-wrap mb-8`} key={`${index}${idx}`}>
                            {mock[tableKey] != null && Object.entries(mock[tableKey]).map(([key, item]) => (
                                <li key={`${key}${index}${idx}`}
                                    className="[&_input]:text-center [&_select]:text-center text-2xl  flex-shrink-0 ">
                                    <div className={`bg-slate-800  text-white text-center py-3 text-2xl      px-8 `}>
                                        {key}
                                    </div>
                                    {renderInput(tableKey, `${key}${idx}${index}`, item)}
                                </li>
                            ))}
                        </ul>
                    </div>)
                )}
                {mockInfo && !Array.isArray(mockInfo) && Object.keys(mockInfo).map((tableKey, idx) => {
                    return <div key={idx} className={`mb-8`}>
                        <h1 className={`text-5xl font-extrabold text-black mb-8 `}>{mockInfo[tableKey] && tableKey}</h1>
                        <ul className={`flex   gap-x-8 gap-y-8 justify-start  flex-wrap mb-8`}>
                            {mockInfo[tableKey] != null && Object.entries(mockInfo[tableKey]).map(([key, item]) => (
                                <li key={key}
                                    className="[&_input]:text-center [&_select]:text-center text-2xl  flex-shrink-0 ">
                                    <div className={`bg-slate-800  text-white text-center py-3 text-2xl      px-8 `}>
                                        {key}
                                    </div>
                                    {renderInput(tableKey, key, item)}
                                </li>
                            ))}
                        </ul>
                    </div>
                })}
                <button className={`py-4 w-full bg-slate-950 text-white mt-4`} onClick={store}>
                    저장하기
                </button>
            </div>

        </div>
    );
}


async function getProblems(templateId, testType) {
    if (testType === 'trans') return []
    const template =
        await axios.get(`${REST_URL}activity_test_problem_view_${testType === 'short' ? testType + '_create' : testType}?&&template_id=eq.${templateId}&&test_id=eq.0`)
    return template.data
}

async function getTemplateMetaData(templateId) {
    const templateMetaData = await axios.get(`${REST_URL}activity_test_template_view_create?id=eq.${templateId}`)
    return Object.fromEntries(Object.entries(templateMetaData.data[0]).filter(([_, value]) => value !== null))
}

const storeNewInstance = async (key, flatData, period) => {
    flatData['교시'] = period
    return axios.post(`${REST_URL}${key}`, flatData, {headers: {'prefer': 'return=representation'}})
        .catch((e) => {
            alert(e)
            console.error(`${period}교시 저장 실패`, e)
        })
}

const toMetaDataArray = (item) => {
    const {id, ...rest} = item
    return rest
}

const toMetaData = (item) => ({
    test_id: item.test_id,
    grading: item.grading,
    keywords: item.keywords,
})

const toMetaDataDetail = (item) => item.hasOwnProperty('allow_space') ?
    {
        allow_space: item.allow_space,
        allow_typo: item.allow_typo,
        test_id: item.test_id,
    } : item.hasOwnProperty('ai') ? {
        ai: item.ai,
        questions: item.questions,
        test_id: item.test_id,
    } : item.hasOwnProperty('to_sound') ? {
        to_sound: item.to_sound,
        translator: item.translator,
        test_id: item.test_id,
    } : null

const toProblem = (item, id, templateId) => ({
    id: id,
    test_id: item.test_id,
    problem: '',
    type_id: item.type_id,
    difficulty_id: item.difficulty_id,
    category_id: item.category_id,
    template_id: item.template_id,
})

const toSelections = (item, problemId) => {
    return item.selections ? item.selections.map(it => ({problem_id: problemId, selection: it})) :
        item.selection ? {problem_id: problemId, selection: item.selection} : null
}